"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _swiftInputMinmaxStyle = require("./swift-input-minmax-style");
var _swiftLabel = _interopRequireDefault(require("./swift-label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _helpers = require("../../helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SwiftInputMinMax = function SwiftInputMinMax(props) {
  //console.log('SwiftInputMinMax - props', props)

  var value = props.value,
    suggestions = props.suggestions,
    suggestionLabels = props.suggestionLabels,
    suggestionFormat = props.suggestionFormat,
    emptyLabel = props.emptyLabel,
    format = props.format,
    onChange = props.onChange,
    onSelectMax = props.onSelectMax,
    allowEqual = props.allowEqual;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    maxFocused = _useState4[0],
    setMaxFocused = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    minFocused = _useState6[0],
    setMinFocused = _useState6[1];
  var refMin = (0, _react.useRef)(false);
  var refMax = (0, _react.useRef)(false);
  var _useState7 = (0, _react.useState)(""),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    valueMin = _useState8[0],
    setValueMin = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    valueMax = _useState10[0],
    setValueMax = _useState10[1];
  (0, _react.useEffect)(function () {
    if (focus == "max" && refMax && refMax.current) {
      //console.log('focusing refmax!! ', refMax)
      refMax.current.focus();
    }
  }, [focus]);
  var handleChange = function handleChange() {
    var vMin = parseInt(valueMin);
    var vMax = parseInt(valueMax);
    if (vMin && vMax) {
      // validate that this min < max and max > min
      if (vMin > vMax) {
        console.log("handleChange, and its greater than the max!!");
        setValueMax("");
        vMax = "";
      } else if (vMax < vMin) {
        console.log("handleChange, and its less than the min!!");
        setValueMin("");
        vMin = "";
      }
    }

    // determine combined value
    var vBoth = null;
    if (vMin && vMax) {
      vBoth = vMin + "-" + vMax;
    } else if (vMin) {
      vBoth = vMin + "+";
    } else if (vMax) {
      vBoth = vMax + "-";
    }

    // send to onchange
    onChange({
      value: vBoth,
      value_min: vMin,
      value_max: vMax
    });
  };
  (0, _react.useEffect)(function () {
    console.log("SwiftInputMinMax - value changing", value);
    if (!value) {
      setValueMin("");
      setValueMax("");
      return;
    }
    if (value.includes("+")) {
      setValueMin(value.replace("+", ""));
      setValueMax("");
    } else if (value.charAt(value.length - 1) == "-") {
      setValueMax(value.replace("-", ""));
      setValueMin("");
    } else if (value.includes("-")) {
      var valueSplit = value.split("-");
      setValueMin(valueSplit[0]);
      setValueMax(valueSplit[1]);
    }
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_swiftInputMinmaxStyle.SwiftInputMinMaxStyled, {
    error: props.error && props.helperText ? true : false,
    children: [props.label && props.label.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "swift-input-minmax-inputs",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "swift-input-minmax-input min",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "swift-input-minmax-input-wrapper",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "text",
            ref: refMin,
            value: valueMin,
            onChange: function onChange(_ref) {
              var val = _ref.currentTarget.value;
              setValueMin(val);
            },
            onFocus: function onFocus(e) {
              e.target.select();
              setFocus("min");
              setMinFocused(true);
            },
            onBlur: function onBlur() {
              setMinFocused(false);
              handleChange();
            }
          }), !minFocused && (!valueMin || format == "cost") ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "swift-input-minmax-input-veneer",
            children: !minFocused && !valueMin ? emptyLabel : !minFocused && format == "cost" ? "$" + parseInt(valueMin).toLocaleString() : null
          }) : null]
        }), suggestions && minFocused && /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            onMouseDown: function onMouseDown() {
              setValueMin("");
              setFocus("max");
            },
            className: !valueMin ? "active" : "",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "No Minimum"
            })
          }), suggestions.slice(0, 8).map(function (elem, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              onMouseDown: function onMouseDown() {
                setValueMin(elem);
                setFocus("max");
              },
              className: valueMin && elem == valueMin ? "active" : "",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: suggestionLabels && Object.keys(suggestionLabels).includes("" + elem) ? suggestionLabels[elem] : format == "cost" ? "$" + (0, _helpers.numberShorten)(elem) : elem == 1 && suggestionFormat != "%s" && suggestionFormat.charAt(suggestionFormat.length - 1) == "s" ? suggestionFormat.substr(0, suggestionFormat.length - 1).replace("%s", elem) : suggestionFormat.replace("%s", elem)
              })
            }, i);
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "swift-input-minmax-divider",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "-"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "swift-input-minmax-input max",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "swift-input-minmax-input-wrapper",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "text",
            ref: refMax,
            value: valueMax,
            onChange: function onChange(_ref2) {
              var val = _ref2.currentTarget.value;
              setValueMax(val);
            },
            onFocus: function onFocus(e) {
              setFocus("max");
              setMaxFocused(true);
              e.target.select();
            },
            onBlur: function onBlur() {
              setMaxFocused(false);
              handleChange();
            }
          }), !maxFocused && (!valueMax || format == "cost") ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "swift-input-minmax-input-veneer",
            children: !maxFocused && !valueMax ? emptyLabel : !maxFocused && format == "cost" ? "$" + parseInt(valueMax).toLocaleString() : null
          }) : null]
        }), suggestions && maxFocused && /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
          children: [suggestions.filter(function (elem) {
            return !valueMin || valueMin <= elem;
          }).slice(0, 8).map(function (elem, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              onMouseDown: function onMouseDown() {
                setValueMax(elem);
              },
              className: valueMax && elem == valueMax ? "active" : "",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: suggestionLabels && Object.keys(suggestionLabels).includes("" + elem) ? suggestionLabels[elem] : format == "cost" ? "$" + (0, _helpers.numberShorten)(elem) : elem == 1 && suggestionFormat != "%s" && suggestionFormat.charAt(suggestionFormat.length - 1) == "s" ? suggestionFormat.substr(0, suggestionFormat.length - 1).replace("%s", elem) : suggestionFormat.replace("%s", elem)
              })
            }, i);
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            onMouseDown: function onMouseDown() {
              setValueMax("");
            },
            className: !valueMax ? "active" : "",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "No Maximum"
            })
          })]
        })]
      })]
    }), props.error && props.helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      error: true,
      children: props.helperText
    }) : null]
  });
};
SwiftInputMinMax.defaultProps = {
  value: null,
  onChange: function onChange() {},
  suggestions: null,
  suggestionLabels: null,
  suggestionFormat: "%s",
  emptyLabel: "Any",
  format: null,
  allowEqual: false,
  onSelectMax: function onSelectMax() {}
};
var _default = SwiftInputMinMax;
exports.default = _default;